// Trip params carried from search/home into a listing's page, in this order.
const CARRIED_PARAMS = [
  "from",
  "to",
  "guest",
  "child",
  "infant",
  "location",
  "address_name",
];

/** A listing's (or hotel's) page, keeping the visitor's dates, guests and location. */
export const listingDetailsHref = (
  id: number | string,
  isHotel: boolean,
  query: Record<string, string | string[] | undefined>,
): string => {
  const base = isHotel ? `/hotel/${id}` : `/listing/${id}`;
  const params = new URLSearchParams();
  for (const key of CARRIED_PARAMS) {
    const value = query[key];
    if (typeof value === "string" && value) params.append(key, value);
  }
  const search = params.toString();
  return search ? `${base}?${search}` : base;
};

/** `href` with `extra` appended to its query (left as is when there is nothing to add). */
export const withQuery = (
  href: string,
  extra: Record<string, string> | undefined,
): string => {
  if (!extra || Object.keys(extra).length === 0) return href;
  const [path = "", search = ""] = href.split("?");
  const params = new URLSearchParams(search);
  for (const [key, value] of Object.entries(extra)) params.set(key, value);
  return `${path}?${params.toString()}`;
};
